import { memo } from 'react'

import { cn } from '@/utils'

import { CueDropzone } from './cue.dnd'
import { useCueDropzone } from './cue.dnd.hooks'

type CueRowDropzoneProps = {
  dropzone: CueDropzone.GROUP | CueDropzone.CUE
  cueId: string
  parentId?: string | null
  /** Last child of a group, which gives up room to the AFTER zone. */
  lastSibling: boolean
}

/**
 * The cue's own dropzone and its "drop here" marker.
 */
export const CueRowDropzone = memo(function CueRowDropzone({
  dropzone,
  cueId,
  parentId,
  lastSibling,
}: CueRowDropzoneProps) {
  const { setNodeRef, isOver } = useCueDropzone({ dropzone, cueId, parentId })

  return (
    <>
      <div
        ref={setNodeRef}
        className={cn(
          'absolute left-0 right-0 pointer-events-none',
          // The last cue in a group also exposes an "insert after" dropzone
          // (below), so its own "drop onto group" zone gives up some room
          lastSibling && parentId ? 'h-1/3 bottom-1/3' : 'h-2/3 bottom-0',
        )}
      />

      <div
        className={cn(
          'absolute z-10 inset-0 bg-blue-500/60 rounded-sm',
          'transition-opacity ease-in-out duration-300',
          isOver ? 'opacity-100' : 'opacity-0 pointer-events-none',
        )}
      />
    </>
  )
})
